import {
  TemplateDefinition, TemplateCommonSection, TemplatePageSection, TemplateText, TemplateLine, TemplateImage,
  TemplateRectangle, TemplateSummary, TemplateDataPlate, TemplateTable, TemplateVisualEvents, TemplateMeasurementPoint,
  TemplateSignature, TemplateSection, TemplateIso, TemplateDropDownList, TemplateSubTotal
} from './report-template';

export type ElementType = 'Page' | 'Text' | 'Line' | 'Image' | 'Rectangle' | 'Summary' | 'SubTotal' | 'Picture'
  | 'DataPlate' | 'MeasurementPoint' | 'VisualEvents' | 'Signature' | 'Section' | 'Table' | 'InteractiveIso' | 'DropDownList' | 'CustomElement';

export namespace ElementType {
  export const Page: ElementType = 'Page';
  export const Text: ElementType = 'Text';
  export const Line: ElementType = 'Line';
  export const Image: ElementType = 'Image';
  export const Rectangle: ElementType = 'Rectangle';
  export const Summary: ElementType = 'Summary';
  export const SubTotal: ElementType = 'SubTotal';
  export const Picture: ElementType = 'Picture';
  export const DataPlate: ElementType = 'DataPlate';
  export const MeasurementPoint: ElementType = 'MeasurementPoint';
  export const VisualEvents: ElementType = 'VisualEvents';
  export const Signature: ElementType = 'Signature';
  export const Section: ElementType = 'Section';
  export const Table: ElementType = 'Table';
  export const InteractiveIso: ElementType = 'InteractiveIso';
  export const DropDownList: ElementType = 'DropDownList';
  export const CustomElement: ElementType = 'CustomElement';

  export function cast(value: string): ElementType {
    let rtnType: ElementType = 'Text';
    const types: ElementType[] = [
      ElementType.Page,
      ElementType.Text,
      ElementType.Line,
      ElementType.Image,
      ElementType.Rectangle,
      ElementType.Summary,
      ElementType.SubTotal,
      ElementType.Picture,
      ElementType.DataPlate,
      ElementType.MeasurementPoint,
      ElementType.VisualEvents,
      ElementType.Signature,
      ElementType.Section,
      ElementType.Table,
      ElementType.InteractiveIso,
      ElementType.DropDownList,
      ElementType.CustomElement
    ];
    for (const type of types) {
      if (type.toLowerCase() === value.trim().toLowerCase()) {
        rtnType = type;
        break;
      }
    }
    return rtnType;
  }
}

export namespace Location {
  export const Header: Location = 'Header';
  export const Body: Location = 'Body';
  export const Footer: Location = 'Footer';
  export const Page: Location = 'Page';

  export function cast(value: string): Location {
    let rtnLoc: Location = 'Body';
    const locs: Location[] = [
      Location.Header,
      Location.Body,
      Location.Footer,
      Location.Page
    ];
    for (const loc of locs) {
      if (loc.toLowerCase() === value.trim().toLowerCase()) {
        rtnLoc = loc;
        break;
      }
    }
    return rtnLoc;
  }
}
export type Location = 'Header' | 'Body' | 'Footer' | 'Page';

export type PropertyType = 'Report Font' | 'Size Unit' | 'Page Margin' | 'Paper Size' | 'Page Header' | 'Page Footer';
export type PropOrElemType = PropertyType | ElementType;
export type TemplateJSON = TemplateDefinition
  | TemplateCommonSection
  | TemplatePageSection
  | TemplateText
  | TemplateLine
  | TemplateImage
  | TemplateRectangle
  | TemplateSummary
  | TemplateSubTotal
  | TemplateDataPlate
  | TemplateTable
  | TemplateVisualEvents
  | TemplateMeasurementPoint
  | TemplateSignature
  | TemplateSection
  | TemplateTable
  | TemplateIso
  | TemplateDropDownList;
